/*
  Guide articles: trace product clicks back to the article.
  - Publishes a "nr_blog_product_click" customer event, which a custom pixel
    (Settings > Customer events) can pass to GA4.
  - Saves the article on the cart as the "Blog article" attribute, so the
    order itself shows which article started the sale.
  The link is never held up: both calls are fire-and-forget.
*/
(function () {
  if (window.nrGuideTracking) return;
  window.nrGuideTracking = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-nr-blog-product]');
    if (!link) return;

    var detail = {
      article: link.dataset.article,
      product: link.dataset.product,
      position: link.dataset.position,
    };

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('nr_blog_product_click', detail);
      }
    } catch (error) {
      /* Tracking must never break the link. */
    }

    try {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Blog article': detail.article } }),
        keepalive: true,
      });
    } catch (error) {
      /* As above. */
    }
  });
})();

/*
  Guide articles: the desktop contents column stays in view and marks the
  section being read.
  The heading nearest the top of the screen (once scrolled past) is current.
*/
(function () {
  if (window.nrGuideContents) return;
  window.nrGuideContents = true;

  var sidebar = document.querySelector('.nr-guide__sidebar');
  if (!sidebar) return;

  var links = sidebar.querySelectorAll('a[href^="#"]');
  var headings = [];
  links.forEach(function (link) {
    var heading = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (heading) headings.push({ heading: heading, link: link });
  });
  if (!headings.length) return;

  var current = null;
  var queued = false;

  function update() {
    queued = false;
    // The sidebar is hidden on phones; skip the work there.
    if (!sidebar.offsetParent) return;

    var next = null;
    for (var i = 0; i < headings.length; i++) {
      if (headings[i].heading.getBoundingClientRect().top > 140) break;
      next = headings[i].link;
    }
    if (next === current) return;
    if (current) current.removeAttribute('aria-current');
    if (next) next.setAttribute('aria-current', 'true');
    current = next;
    place();
  }

  // The column stays in view below the header. A list taller than the window
  // (long guides on laptops) slides up only as far as it needs to keep the
  // section being read on screen, so it never needs a scroll bar of its own.
  var topMax = 0;
  var topMin = 0;
  var fitQueued = false;

  function place() {
    var top = topMax;
    if (topMin < topMax && current) {
      var row = current.parentNode;
      // Leave about two rows below the current one in view.
      var wanted = window.innerHeight - 24 - (row.offsetTop + row.offsetHeight * 3);
      top = Math.max(topMin, Math.min(topMax, wanted));
    }
    sidebar.style.top = top + 'px';
  }

  function fit() {
    fitQueued = false;
    if (!sidebar.offsetParent) return;
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    topMax = header + 24;
    topMin = window.innerHeight - 24 - sidebar.offsetHeight;
    place();
  }

  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    requestAnimationFrame(fit);
  }

  window.addEventListener('resize', queueFit, { passive: true });
  // Web fonts can change the list's height after the first check.
  window.addEventListener('load', queueFit);

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  update();
  fit();
})();
